import { useState } from "react";
import { useNavigate } from "react-router-dom";
import InlineLoader from "../../components/atoms/inlineLoader";
import ErrorAlert from "../../components/atoms/alerts/errorAlert";
import SuccessAlert from "../../components/atoms/alerts/successAlert";
import { useStore } from "../../store";
import {useForm} from 'react-hook-form';
import { regex } from "../../utils/regexPaterns";
const SignUp = () => {
    const title = 'Company Sign Up'
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    // const [postalcode, setPostalcode] = useState("");
    const { layoutStore } = useStore();
    const navigate = useNavigate();
    const {
        register,
        handleSubmit,
        formState: { errors },
      } = useForm();
    const onSubmit = (data) => { 
        setLoading(true);
        setSuccess(false);
        layoutStore.initiateSignUp(data).then((resp) => {
            if (resp.error) {
                setError(resp.error);
            }
            else {
                setSuccess(true);
            }
            setLoading(false);
        })
     };
    return (
        <>
            <div className="flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8">
                <div className="sm:mx-auto sm:w-full sm:max-w-md">
                    <h1 className='font-black text-2xl text-center cursor-pointer border-b-2 pb-2 text-blue-700'
                    >
                        {title}
                    </h1>
                    <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">Create A New Account</h2>
                </div>
                <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-2xl">
                    <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                        {/* {error && <ErrorAlert title={error} />} */}
                        {/* Make a Grid For SM:2 */}
                        {!success &&
                            <form className="grid grid-cols-1 gap-6 sm:grid-cols-2"
                                 onSubmit={handleSubmit(onSubmit)}
                                // onSubmit={(e) => {
                                //     e.preventDefault();
                                //     // setLoading(true);
                                //     // Convert Form Data to JSON
                                //     const formData = new FormData(e.target);
                                //     const data = Object.fromEntries(formData.entries());
                                //     setError(null);
                                    // setSuccess(false);
                                    // layoutStore.initiateSignUp(data).then((resp) => {
                                    //     if (resp.error) {
                                    //         setError(resp.error);
                                    //     }
                                    //     else {
                                    //         setSuccess(true);
                                    //     }
                                    //     setLoading(false);
                                    // })
                                // }}

                            >
                                <div>
                                    <div className="flex justify-between">
                                        <label htmlFor="contactPerson" className="block text-sm font-medium text-gray-700">
                                            Full Name
                                            <span className="asterisk">*</span>
                                        </label>

                                    </div>
                                    <div className="mt-1">
                                        <input
                                            type="text"
                                            name="contactPerson"
                                            placeholder="John Doe"
                                            className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                            {...register('contactPerson', { required: true , pattern: regex.regexForName})}
                                        />
                                        {errors.contactPerson && (errors.contactPerson.type === 'required' ? <span className="error-message">This field is required</span> : <span className="error-message">Enter a valid Name</span>)}
                                    </div>
                                </div>
                                <div>
                                    <div className="flex justify-between">
                                        <label htmlFor="jobTitle" className="block text-sm font-medium text-gray-700">
                                            Job Title
                                            <span className="asterisk">*</span>
                                        </label>

                                    </div>
                                    <div className="mt-1">
                                        <input
                                            type="text"
                                            name="jobTitle"
                                            placeholder="HR"
                                            className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                            {...register('jobTitle', { required: true })}
                                        />
                                            {errors.jobTitle && <span className="error-message">This field is required</span>}
                                    </div>
                                </div>
                                <div>
                                    <div className="flex justify-between">
                                        <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                            Email
                                            <span className="asterisk">*</span>
                                        </label>

                                    </div>
                                    <div className="mt-1">
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="john@domain.com"
                                            className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                            {...register('email', { required: true, pattern: regex.regexForEmail  })}
                                        />
                                        {errors.email && (errors.email.type === 'required' ? <span className="error-message">This field is required</span> : <span className="error-message">Enter a valid Email ID</span>)}
                                    </div>
                                </div>
                                {/* Primary Info */}
                                <div>
                                    <div className="flex justify-between">
                                        <label htmlFor="licenseHolder" className="block text-sm font-medium text-gray-700">
                                            Sponsored Licence Holder
                                        </label>

                                    </div>
                                    <div className="mt-1">
                                        <select
                                            id="licenseHolder"
                                            name="licenseHolder"
                                            className="mt-1 block w-full rounded-md border-gray-300 hover:border-blue-500 py-2 pl-3 pr-10 text-base focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
                                            {...register('licenseHolder', { required: true })}
                                        >
                                            <option value={"Yes"} >Yes</option>
                                            <option value={"No"}>No</option>
                                        </select>
                                    </div>
                                </div>
                                <div>
                                    <div className="flex justify-between">
                                        <label htmlFor="companySize" className="block text-sm font-medium text-gray-700">
                                            Company Size
                                        </label>

                                    </div>
                                    <div className="mt-1">
                                        <select
                                            id="companySize"
                                            name="companySize"
                                            className="mt-1 block w-full rounded-md border-gray-300 hover:border-blue-500 py-2 pl-3 pr-10 text-base focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
                                            {...register('companySize', { required: true })}
                                        >
                                            <option>1-10</option>
                                            <option>11-50</option>
                                            <option>51-100</option>
                                            <option>101-500</option>
                                            <option>501-1000</option>
                                            <option>1000+</option>
                                        </select>
                                    </div>
                                </div>
                                <div>
                                    <div className="flex justify-between">
                                        <label htmlFor="companyName" className="block text-sm font-medium text-gray-700">
                                            Company Name
                                            <span className="asterisk">*</span>
                                        </label>

                                    </div>
                                    <div className="mt-1">
                                        <input
                                            type="text"
                                            name="companyName"
                                            placeholder="Earth Corp"
                                            className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                            {...register('companyName', { required: true })}
                                        />
                                            {errors.companyName && <span className="error-message">This field is required</span>}
                                    </div>
                                </div>
                                {/* Company Info */}
                                <hr className="sm:col-span-2" />
                                <div>
                                    <div className="flex justify-between">
                                        <label htmlFor="ospreyNum" className="block text-sm font-medium text-gray-900">
                                            Osprey File Reference Number
                                            <span className="asterisk">*</span>
                                        </label>

                                    </div>
                                    <div className="mt-1">
                                        <input
                                            type="text"
                                            name="ospreyNum"
                                            placeholder="Osprey File Reference Number" 
                                            className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                            {...register('ospreyNum', { 
                                                required: "This field is required",
                                                pattern: {
                                                    value: /^[a-zA-Z0-9/-//]*$/, // Alphanumeric pattern
                                                    message: "Only alphanumeric characters are allowed"
                                                }
                                            })}
                                        />
                                            {errors.ospreyNum && <span className="error-message">{errors.ospreyNum.message}</span>}
                                    </div>
                                </div>
                                <div>
                                    <div className="flex justify-between">
                                        <label htmlFor="website" className="block text-sm font-medium text-gray-700">
                                            Website
                                            {/* <span className="asterisk">*</span> */}
                                        </label>

                                    </div>
                                    <div className="mt-1">
                                        <input
                                            type="text"
                                            name="website"
                                            placeholder="https://www.example.com"
                                            className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                            {...register('website', { pattern: regex.regexForURL })}
                                        />
                                            {errors.website && (errors.website.type === 'required' ? <span className="error-message">This field is required</span> : <span className="error-message">Enter a valid Website Full URL</span>)}
                                    </div>
                                </div>
                                <div>
                                    <div className="flex justify-between">
                                        <label htmlFor="phone" className="block text-sm font-medium text-gray-700">
                                            Phone
                                            <span className="asterisk">*</span>
                                        </label>

                                    </div>
                                    <div className="mt-1">
                                        <input
                                            type="tel"
                                            name="phone"
                                            placeholder="+447222555555"
                                            className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                            {...register('phone', { required: true , pattern: regex.regexForPhone, maxLength:20})}
                                        />
                                            {errors.phone && (errors.phone.type === 'required' ? <span className="error-message">This field is required</span> : <span className="error-message">Enter a valid Phone No.</span>)}
                                    </div>
                                </div>
                                <div>
                                    <div className="flex justify-between">
                                        <label htmlFor="landline" className="block text-sm font-medium text-gray-700">
                                            Landline
                                        </label>

                                    </div>
                                    <div className="mt-1">
                                        <input
                                            type="tel"
                                            name="landline"
                                            className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                            {...register('landline', { pattern: regex.regexForPhone, maxLength:20 })}
                                        />
                                            {errors.landline && <span className="error-message">Landline Number is not valid.</span>}
                                    </div>
                                </div>
                                <div>
                                    <div className="flex justify-between">
                                        <label htmlFor="address1" className="block text-sm font-medium text-gray-700">
                                            Address Line 1
                                            <span className="asterisk">*</span>
                                        </label>

                                    </div>
                                    <div className="mt-1">
                                        <input
                                            type="text"
                                            name="address1"
                                            placeholder="1234 Main St"
                                            className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                            {...register('address1', { required: true , pattern: regex.regexForAddress})}
                                        />
                                        {errors.address1 && (errors.address1.type === 'required' ? <span className="error-message">This field is required</span> : <span className="error-message">Enter a valid Address</span>)}
                                    </div>
                                </div>
                                <div>
                                    <div className="flex justify-between">
                                        <label htmlFor="address2" className="block text-sm font-medium text-gray-700">
                                            Address Line 2
                                        </label>

                                    </div>
                                    <div className="mt-1">
                                        <input
                                            type="text"
                                            name="address2"
                                            className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                            {...register('address2', { pattern: regex.regexForAddress})}
                                        />
                                            {errors.address2 && <p className="error-message">Address is not valid.</p>}
                                    </div>
                                </div>
                                <div>
                                    <div className="flex justify-between">
                                        <label htmlFor="city" className="block text-sm font-medium text-gray-700">
                                            City
                                            <span className="asterisk">*</span>
                                        </label>

                                    </div>
                                    <div className="mt-1">
                                        <input
                                            type="text"
                                            name="city"
                                            placeholder="London"
                                            className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                            {...register('city', { required: true , pattern: regex.regexForName})}
                                        />
                                            {errors.city && (errors.city.type === 'required' ? <span className="error-message">This field is required</span> : <span className="error-message">Enter a valid City Name</span>)}
                                    </div>
                                </div>
                                <div>
                                    <div className="flex justify-between">
                                        <label htmlFor="postcode" className="block text-sm font-medium text-gray-700">
                                            Postal Code
                                            <span className="asterisk">*</span>
                                        </label>

                                    </div>
                                    <div className="mt-1">
                                        <input
                                            type="text"
                                            name="postcode"
                                            max={10}
                                            min={4}
                                            // value={postalcode}
                                            // onChange={(e) => setPostalcode(e.target.value.toUpperCase())}
                                            placeholder="SW1A 2AA"
                                            className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                            // {...register('postcode', { required: true , pattern: regex.regexForUKPostcodes })}
                                            {...register('postcode', { required: true, maxLength: 10, minLength: 4 })}
                                        />
                                            {errors.postcode && (errors.postcode.type === 'required' ? <span className="error-message">This field is required</span> : <span className="error-message">Allowed Postal Code length is 4 to 10</span>)}
                                    </div>
                                </div>
                                <div>
                                    <div className="flex justify-between">
                                        <label htmlFor="country" className="block text-sm font-medium text-gray-700">
                                            Country
                                            <span className="asterisk">*</span>
                                        </label>

                                    </div>
                                    <div className="mt-1">
                                        <input
                                            type="text"
                                            name="country"
                                            placeholder="United Kingdom"
                                            className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                            {...register('country', { required: true , pattern: regex.regexForName})}
                                        />
                                            {errors.country && (errors.country.type === 'required' ? <span className="error-message">This field is required</span> : <span className="error-message">Enter a valid Country Name</span>)}
                                    </div>
                                </div>
                                <button
                                    type="submit"
                                    disabled={loading}
                                    className="sm:col-span-2 flex w-full justify-center rounded-md border border-transparent bg-blue-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                >

                                    {
                                        loading ? "Please wait..." : "Create An Account"
                                    }
                                    {
                                        loading && <InlineLoader />
                                    }
                                </button>
                            </form>
                        }
                        {error && <ErrorAlert title={error} />}
                        {success && <SuccessAlert
                            title={"Account Created Successfully"}
                            // message={"Please check your email for the reset link. If you don't see it in your inbox, please check your spam folder."}
                            message={"Your company signup request has been created successfully. You will receive an email when your request is approved or rejected. If you don't see it in your inbox, please check your spam folder."}
                        />}
                        <div className="text-center mt-4">
                            <p className="text-sm text-gray-600">
                                Already have an account?{" "}
                                <span
                                    onClick={() => {
                                        navigate("/login");
                                    }}
                                    className="cursor-pointer font-medium text-blue-600 hover:text-blue-500">
                                    Login
                                </span>
                            </p>
                        </div>
                    </div>
                </div >
                <div className="mt-3 pt-3 text-center">
                    <a className="text-sm text-gray-600"
                        href="https://sponsorlicencecompliance.com/terms"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Terms & Conditions
                    </a>
                </div>
            </div >
        </>
    );
}
export default SignUp;